<template>
  <button
    class="btn btn-dynamic"
    :class="className"
    @click="onClick"
  >
    <transition name="up">
      <div
        v-if="loading === false && success === false"
        class="text"
      >
        {{ text }}
      </div>
    </transition>
    <transition name="up">
      <span
        v-if="success"
        class="oi oi-check"
      />
    </transition>
    <transition name="up">
      <span
        v-if="error"
        class="oi oi-x"
      />
    </transition>
  </button>
</template>

<script>
export default {
  name: 'DynamicButton',
  props: {
    text: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    success: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    className: function () {
      if (this.loading === true) return 'btn-primary btn-loading'
      if (this.error === true) return 'btn-danger'
      if (this.success === true) return 'btn-success'
      return 'btn-primary'
    }
  },
  watch: {
    loading: function (val) {
      if (val === true) {
        this.error = false
        this.success = false
      }
    },
    error: function (val) {
      if (val === true) {
        this.loading = false
        this.success = false
      }
    },
    success: function (val) {
      if (val === true) {
        this.loading = false
        this.error = false
      }
    }
  },
  methods: {
    onClick: function () {
      this.$emit('onClick')
    }
  }
}
</script>

<style scoped lang="scss">

  .btn-dynamic {
    transition: all 0.1s;
    outline: none;
    overflow: hidden;
    min-width: 150px;
    position: relative;
    height: 42px;
    background:transparent !important;
    border-color:transparent !important;
    box-shadow:none !important;
    z-index:2;
    width:100%;
    max-width:300px;
    display:block;
    margin-left:auto;
    margin-right:auto;

    &:before {
      content:"";
      transition: all 0.1s;
      position: absolute;
      width:100%;
      left:0;
      top:50%;
      transform:translateY(-50%);
      height: 100%;
      background-color: #ff8708;
      border-radius:inherit;
      transition: all 0.2s ease;
      z-index:-1;
    }

    &:after {
      content: '';
      width: 0%;
      background: #ff8708;
      height:100%;
      display: block;
      top:50%;
      transform:translateY(-50%);
      left: 0;
      position: absolute;
      border-radius:inherit;
      transition: all 0.2s ease;
    }

    &:hover {
      &:before {
        background:#e17400;
      }
    }

    @media (min-width:768px) {
      max-width:200px;
    }
  }

  .btn-loading {

    &:before {
      background-color: #ffb261 !important;
      height:20px;
      transition: height 0.2s ease;
    }

    &:after {
      height:20px;
      width: 97%;
      transition: height 0.2s ease, width 3s cubic-bezier(.25,1.13,.85,.99) 0.2s;
    }
  }

  .btn-success {
    &:before {
      background-color: #52CF97 !important;
    }
  }

  .btn-error, .btn-danger {
    &:before {
      background-color: #FF4D4D !important;
    }
  }

.btn-success, .btn-error, .btn-danger {
  padding: 0.625rem 2rem !important;
}

.oi{
  transition: all 0.3s;
  transform: translateY(0px);
  height: 20px;
}

.up-enter-active {
  transition: all .3s ease;
}

.up-enter, .up-leave-to {
  transform: translateY(40px) rotate(55deg);
  opacity: 0;
}

.up-active, .up-leave-active {
  transition: all 0.3s
}
.up-enter, .up-leave-to {
  opacity: transformY(40px);
}
</style>
